const CLIENT_LOGOS = [
  { name: 'Raia Drogasil', src: '/logos/raia-drogasil.png' },
  { name: 'Tok&Stok', src: '/logos/tok-stok.png' },
  { name: 'Elfa', src: '/logos/elfa.png' },
  { name: 'Via', src: '/logos/via-varejo.webp' },
  { name: 'Klabin', src: '/logos/Klabin.png' },
  { name: 'Cobasi', src: '/logos/cobasi.png' },
  { name: 'JHSF', src: '/logos/JHSF.webp' },
  { name: 'BRF', src: '/logos/brf.png' },
  { name: 'Magalu', src: '/logos/Magalu.png' },
  { name: 'BTG Pactual', src: '/logos/btg.png' },
  { name: 'Oswaldo Cruz', src: '/logos/Oswaldo-cruz.png' },
  { name: 'Liberty Seguros', src: '/logos/liberty-seguros.png' },
  { name: 'Dexco', src: '/logos/dexco.webp' },
  { name: 'Rodobens', src: '/logos/rodobens.png' },
]

export default function ClientLogosMarquee() {
  return (
    <div className="relative overflow-hidden [mask-image:linear-gradient(to_right,transparent,black_10%,black_90%,transparent)]">
      <div className="flex w-max animate-marquee hover:[animation-play-state:paused]">
        {[...CLIENT_LOGOS, ...CLIENT_LOGOS].map((logo, i) => (
          <div
            key={`${logo.name}-${i}`}
            className="mx-6 flex h-28 w-56 flex-shrink-0 items-center justify-center"
          >
            <img
              src={logo.src}
              alt={logo.name}
              className="max-h-full max-w-full object-contain brightness-0 opacity-60 dark:invert"
            />
          </div>
        ))}
      </div>
    </div>
  )
}
